import { makeStyles, ThemeProvider } from "@material-ui/styles"
import grey from "@material-ui/core/colors/grey"

const useStyles = makeStyles(theme => {
  const mediaScreenXs = `@media only screen and (max-width: ${theme.breakpoints.values.sm}px)`
  return {
    tokenSelection: {
      width: 260,
      [mediaScreenXs]: {
        width: "100%",
      },
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: 0,
    },
    tokenSelectionSelect: {
      height: 50,
      "& select": {
        background: "transparent !important",
      },
    },
    poweredByNotice: {
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
    },
    poweredByNotice_mobile: {
      marginTop: theme.spacing(0.5),
    },
    sourceText: {
      color: grey[500],
      fontSize: "0.8rem",
      marginRight: theme.spacing(1),
    },
    addressSection: {
      flex: 1,
      marginTop: theme.spacing(2),
    },
    addressForm: {
      flex: 1,
      paddingLeft: theme.spacing(2),
    },
    addressInput: {
      width: "100%",
      "& #mainnetAddressField": {
        padding: 10,
        height: 30, // with padding 30 + 10 + 10 = 50 (same height as buttons)
      },
    },
    wrapper: {
      display: "flex",
      flexDirection: "row",
      [mediaScreenXs]: {
        flexDirection: "column",
      },
    },
    mainnetAddressSubmit: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      width: "100%",
      height: "100%",
    },
    extractCodeButton: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [mediaScreenXs]: {
        paddingLeft: 0,
        paddingTop: theme.spacing(2),
      },
    },
    codeExtractedNotice: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [mediaScreenXs]: {
        marginLeft: 0,
        display: "flex",
        justifyContent: "center",
        paddingTop: theme.spacing(1),
      },      
      display: "flex",
      alignItems: "center",
    },    
    dateListCreatedText: {
      display: "inline-block",
    },
    tokenSelectWrapper: {
      marginLeft: theme.spacing(2),
    },
    tokenSelectWrapper_mobile: {
      marginBottom: theme.spacing(2),
    },
  }
})

export default useStyles
